import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '../lib/api';
import { useAuthStore } from '../stores/authStore';
import { Settings, Inbox, Save, Loader, ArrowDownToLine, ArrowUpFromLine } from 'lucide-react'; // [PATCH nastavitve-zavihki v1] ArrowLeft ni vec v rabi
import { Hash, BookOpen, Globe, MoreHorizontal } from 'lucide-react'; // [PATCH nastavitve-izdani v2] ikone zavihkov Prodaje
import { Truck as IkonaDobava } from 'lucide-react'; // [PATCH dobavnica-cmr-fe v1]
/* [PATCH nastavitve-zavihki v1] zavihki + kartice profila, preseljene s ProfilPage */
import { useSearchParams } from 'react-router-dom';
import { smerAplikacije, preberiAplikacijo } from '../aplikacije'; // [PATCH aplikacije-fe v3] smer po aktivni aplikaciji
import { Zavihki } from '../components/Zavihki';
import { useProfil } from '../hooks/useProfil';
import { RacunPlacanKartica } from '../components/nastavitve/RacunPlacanKartica';
import { VkrNastavitveKartica } from '../components/nastavitve/VkrNastavitveKartica'; // [PATCH miniblagajna-fe v1]
import { PopravljanjeRacunaKartica } from '../components/nastavitve/PopravljanjeRacunaKartica'; // [PATCH izdaja-potrditev-fe v1]
import { ZbirniKupecKartica } from '../components/nastavitve/ZbirniKupecKartica';
import { PredponeKartica } from '../components/nastavitve/PredponeKartica';
import { DdvKontiKartica } from '../components/nastavitve/DdvKontiKartica';
import { IzdaniInternaKartica } from '../components/nastavitve/IzdaniInternaKartica'; /* [PATCH izdani-interna-originalna v1] */
import { DdvKlavzule } from '../components/DdvKlavzule';
import { OssDrzaveKartica } from '../components/nastavitve/OssDrzaveKartica'; /* [PATCH oss-temelji v1] */
import { LikvidacijaKartica } from '../components/nastavitve/LikvidacijaKartica'; /* [PATCH likvidacija-fe v1] */
import { DobavnicaCmrKartica } from '../components/nastavitve/DobavnicaCmrKartica'; // [PATCH dobavnica-cmr-fe v1]
import { IzdajaKartica } from '../components/nastavitve/IzdajaKartica'; // [PATCH izdaja-ui v1] // [PATCH izdaja-vsem v1b] nazaj: nastavitve oblike ostanejo, stikalo je skrito v kartici
import { PrenosPdfKartica } from '../components/nastavitve/PrenosPdfKartica'; // [PATCH prenos-pdf-nastavitev v1]
import { VezaInternaKartica } from '../components/nastavitve/VezaInternaKartica'; // [PATCH vod-veza-interna v1]
import { PrivzetiSmKartica } from '../components/nastavitve/PrivzetiSmKartica'; // [PATCH vod-privzeti-dim-fe v1]
import { ZaklepLetaKartica } from '../components/nastavitve/ZaklepLetaKartica'; // [PATCH zaklep-leta-fe v1]

/* [PATCH nastavitve-zavihki v1] */
const ZAVIHKI = [
  { id: 'splosne', label: 'Splošne nastavitve', icon: Settings },
  /* [PATCH nastavitve-prejeti v1] Nabava: trije zavihki namesto 'Prejeti racuni' */
  { id: 'p_stevilcenje', label: 'Številčenje', icon: Hash },
  { id: 'p_kontiranje', label: 'Kontiranje', icon: BookOpen },
  { id: 'p_ostalo', label: 'Ostalo', icon: ArrowDownToLine },
  /* [PATCH nastavitve-izdani v2] Prodaja: pet zavihkov namesto 'Izdani racuni' (v Prodaji smo ze) */
  { id: 'stevilcenje', label: 'Številčenje', icon: Hash },
  { id: 'kontiranje', label: 'Kontiranje', icon: BookOpen },
  { id: 'rocni', label: 'Ročni vnos računa', icon: ArrowUpFromLine },
  { id: 'dobava', label: 'Dobavnica / CMR', icon: IkonaDobava }, // [PATCH dobavnica-cmr-fe v1]
  { id: 'oss', label: 'OSS države', icon: Globe },
  { id: 'ostalo', label: 'Ostalo', icon: MoreHorizontal },
  /* [PATCH likvidacija-zavihek v1] zavihek 'podjetje' odstranjen - Likvidacija je zdaj pri Prejetih racunih */
];

// [PATCH bizbox-prevzem v6] — stran Nastavitve (bizBox + prostor za bodoče sekcije)
export function NastavitvePage() {
  const selectedCompany = useAuthStore((s: any) => s.selectedCompany);
  const companyId = selectedCompany?.id;
  /* [PATCH nastavitve-zavihki v1] aktiven zavihek v URL (?tab=), da preziveti osvezitev */
  const [sp, setSp] = useSearchParams();
  const tabIzUrl = ({ izdani: 'rocni', prejeti: 'p_stevilcenje' } as Record<string, string>)[sp.get('tab') || ''] || sp.get('tab') || 'splosne'; /* [PATCH nastavitve-izdani v2] */ /* [PATCH nastavitve-prejeti v1] stari povezavi */
  /* [PATCH aplikacije-fe v3] zavihek nasprotne smeri skrit: Prodaja -> brez Prejetih, Nabava -> brez Izdanih */
  const smerApl = smerAplikacije(preberiAplikacijo());
  const IZDANI_ZAVIHKI = ['stevilcenje', 'kontiranje', 'rocni', 'dobava', 'oss', 'ostalo']; /* [PATCH dobavnica-cmr-fe v1] + dobava */ /* [PATCH nastavitve-izdani v2] */
  const PREJETI_ZAVIHKI = ['p_stevilcenje', 'p_kontiranje', 'p_ostalo']; /* [PATCH nastavitve-prejeti v1] */
  const vlogaNast = useAuthStore((s: any) => s.role); /* [PATCH nastavitve-izdani v2b] */
  const ZAVIHKI_APL = (vlogaNast === 'stranka' && smerApl === 'izdani_racun')
    ? ZAVIHKI.filter(z => z.id === 'rocni' || z.id === 'dobava') /* [PATCH dobavnica-cmr-fe v1] */ /* [PATCH nastavitve-izdani v2b] stranka v Prodaji: samo Rocni vnos racuna */
    : ZAVIHKI.filter(z => z.id === 'splosne' || !smerApl || (smerApl === 'izdani_racun' ? IZDANI_ZAVIHKI.includes(z.id) : PREJETI_ZAVIHKI.includes(z.id))); /* [PATCH nastavitve-prejeti v1] */
  const tab = ZAVIHKI_APL.some(z => z.id === tabIzUrl) ? tabIzUrl : (ZAVIHKI_APL[0]?.id || 'splosne'); /* [PATCH nastavitve-izdani v2b] privzeto prvi dovoljeni zavihek */
  const p = useProfil(companyId || '');
  const [nalagam, setNalagam] = useState(true);
  const [shranjujem, setShranjujem] = useState(false);
  const [okolje, setOkolje] = useState('demo');
  const [uporabnik, setUporabnik] = useState('');
  const [geslo, setGeslo] = useState('');
  const [nastavljeno, setNastavljeno] = useState(false);
  const [odDatuma, setOdDatuma] = useState(''); // [PATCH bizbox-prevzem v7]
  /* [PATCH ddv-blokada v1] */
  const [ddvBlokada, setDdvBlokada] = useState('');        // 'YYYY-MM' ali ''
  const [pStev, setPStev] = useState('davcna');  // [PATCH partner-stevilcenje v1]
  const [pStevSpor, setPStevSpor] = useState('');
  // [PATCH partner-sifra-xml v1] Uvoz novih partnerjev preko XML: ali se prevzame sifra iz datoteke.
  const [pXml, setPXml] = useState(false);
  const [pXmlSpor, setPXmlSpor] = useState('');
  const [ddvEdit, setDdvEdit] = useState(false);
  const [ddvVnos, setDdvVnos] = useState('');              // vnos MM.YYYY
  const [ddvShranjujem, setDdvShranjujem] = useState(false);
  const [ddvSporocilo, setDdvSporocilo] = useState('');
  useEffect(() => {
    if (!companyId) return;
    setDdvBlokada(''); setDdvEdit(false); setDdvVnos(''); setDdvSporocilo('');
    api.get(`/companies/${companyId}/ddv-blokada`)
      .then(r => setDdvBlokada(r.data?.ddv_blokada_do || ''))
      .catch(() => {});
    api.get(`/companies/${companyId}/partner-stevilcenje`)  // [PATCH partner-stevilcenje v1]
      .then(r => setPStev(r.data?.partner_stevilcenje || 'davcna'))
      .catch(() => {});
    api.get(`/companies/${companyId}/partner-sifra-iz-xml`)  // [PATCH partner-sifra-xml v1]
      .then(r => setPXml(!!r.data?.partner_sifra_iz_xml))
      .catch(() => {});
  }, [companyId]);
  const shraniDdvBlokado = async (kanon: string) => {   // kanon: 'YYYY-MM' ali ''
    setDdvShranjujem(true); setDdvSporocilo('');
    try {
      await api.put(`/companies/${companyId}/ddv-blokada`, { ddv_blokada_do: kanon });
      setDdvBlokada(kanon); setDdvEdit(false); setDdvVnos('');
      setDdvSporocilo(kanon ? `Blokada nastavljena do vključno ${kanon.slice(5,7)}.${kanon.slice(0,4)}.` : 'Blokada odstranjena.');
    } catch (e: any) {
      setDdvSporocilo(e?.response?.data?.detail || 'Shranjevanje ni uspelo.');
    } finally { setDdvShranjujem(false); }
  };
  const potrdiDdvVnos = () => {
    const m = (ddvVnos || '').trim().match(/^(0[1-9]|1[0-2])\.(\d{4})$/);
    if (!m) { setDdvSporocilo('Vnesi obdobje kot MM.YYYY, npr. 04.2026.'); return; }
    shraniDdvBlokado(`${m[2]}-${m[1]}`);
  };

  useEffect(() => {
    if (!companyId) { setNalagam(false); return; }
    setNalagam(true);
    api.get(`/bizbox/${companyId}/status`)
      .then(r => {
        setUporabnik(r.data?.uporabnik || '');
        setOkolje(r.data?.okolje === 'prod' ? 'prod' : 'demo');
        setNastavljeno(!!r.data?.nastavljeno);
        setOdDatuma(r.data?.od_datuma || '');
      })
      .catch(() => {})
      .finally(() => setNalagam(false));
  }, [companyId]);

  const shrani = async () => {
    if (!uporabnik.trim()) { toast.error('Vnesite uporabniško ime'); return; }
    if (!geslo && !nastavljeno) { toast.error('Vnesite geslo'); return; }
    setShranjujem(true);
    try {
      await api.post(`/bizbox/${companyId}/poverilnice`,
        { uporabnik: uporabnik.trim(), geslo, okolje, od_datuma: odDatuma });
      setGeslo('');
      setNastavljeno(true);
      toast.success('bizBox nastavitve shranjene');
    } catch (e: any) {
      toast.error(e.response?.data?.detail || 'Shranjevanje ni uspelo');
    } finally { setShranjujem(false); }
  };

  if (!selectedCompany) {
    return (
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-12 text-center">
        <Settings className="w-12 h-12 text-gray-300 mx-auto mb-4" />
        <p className="text-gray-500 dark:text-gray-400">Najprej izberite podjetje na nadzorni plošči.</p>
      </div>
    );
  }

  return (
    <div className="space-y-5">
      {/* [PATCH nastavitve-zavihki v1] inline gumb odstranjen — gumb je zdaj skupen
          v DashboardLayout (NazajGumb), sicer bi bil dvojni. */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Nastavitve</h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">{selectedCompany.name}</p>
      </div>

      {/* [PATCH nastavitve-zavihki v1] vrstica zavihkov; gumb Shrani velja za profilne kartice */}
      <Zavihki
        zavihki={ZAVIHKI_APL} /* [PATCH aplikacije-fe v3] zavihki po aplikaciji */
        aktiven={tab}
        onIzberi={(id) => setSp(id === 'splosne' ? {} : { tab: id })}
        desno={tab !== 'splosne' && vlogaNast !== 'stranka' ? (/* [PATCH nastavitve-izdani v2b] stranka nima gumba Shrani */
          <button onClick={p.shrani} disabled={p.saving || p.loading}
            className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-xl text-sm font-medium transition">
            {p.saving ? <Loader className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
            Shrani
          </button>
        ) : null}
      />

      {/* [PATCH nastavitve-zavihki v1] zavihek PREJETI RACUNI */}
      {PREJETI_ZAVIHKI.includes(tab) && (/* [PATCH nastavitve-prejeti v1] */
        p.loading || !p.data ? (
          <div className="text-sm text-gray-500 dark:text-gray-400">Nalagam …</div>
        ) : (
          <div className="space-y-5">{/* [PATCH nastavitve-prejeti v1] vsebina po zavihku */}
            {tab === 'p_stevilcenje' && (
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 items-start">
                <PredponeKartica smer="prejeti" data={p.data} set={p.set} />
              </div>
            )}
            {tab === 'p_kontiranje' && (<>
              <DdvKontiKartica smer="prejeti" data={p.data} set={p.set} />
              {!p.data.ni_zavezanec_ddv && <DdvKlavzule />}
            </>)}
            {tab === 'p_ostalo' && (
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 items-start">
                <RacunPlacanKartica smer="prejeti" data={p.data} set={p.set} companyId={companyId} />
                {/* [PATCH likvidacija-zavihek v1] preseljeno z zavihka Podjetje */}
                {companyId && <LikvidacijaKartica companyId={companyId} />}
                {companyId && <PrivzetiSmKartica companyId={companyId} />}{/* [PATCH vod-privzeti-dim-fe v1] */}
              </div>
            )}
          </div>
        )
      )}

      {/* [PATCH nastavitve-zavihki v1] zavihek IZDANI RACUNI */}
      {IZDANI_ZAVIHKI.includes(tab) && (/* [PATCH nastavitve-izdani v2] en ovoj, vsebina po zavihku */
        p.loading || !p.data ? (
          <div className="text-sm text-gray-500 dark:text-gray-400">Nalagam …</div>
        ) : (
          <div className="space-y-8">{/* [PATCH nastavitve-izdani v1] */}{/* [PATCH nastavitve-izdani v2] zavihki */}
            {tab === 'stevilcenje' && (<section>
              <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 items-start">
                <IzdaniInternaKartica data={p.data} set={p.set} />{/* [PATCH izdani-interna-originalna v1] */}
                {companyId && <VezaInternaKartica companyId={companyId} />}{/* [PATCH vod-veza-interna v1] */}
                <PredponeKartica smer="izdani" data={p.data} set={p.set} />
              </div>
            </section>)}
            {tab === 'kontiranje' && (<section>
              <DdvKontiKartica smer="izdani" data={p.data} set={p.set} />
            </section>)}
            {tab === 'rocni' && (<section>
              {/* [PATCH izdaja-dokumenti v1] oblika, logotip, predloge, stevilcne vrste */}{/* [PATCH izdaja-vsem v1b] */}
              {companyId && <IzdajaKartica companyId={companyId} />}
            </section>)}
            {tab === 'dobava' && (<section>{/* [PATCH dobavnica-cmr-fe v1] */}
              {companyId && <DobavnicaCmrKartica companyId={companyId} />}
            </section>)}
            {tab === 'oss' && (<section>
              {/* [PATCH oss-temelji v1] OSS drzave (unijska ureditev VEM). Lastno stanje in lasten API (/oss/...),
                  zato ne uporablja p.data/p.set profila -- konti OSS niso v ddv_konti. */}
              <OssDrzaveKartica companyId={companyId} />
            </section>)}
            {tab === 'ostalo' && (<section>
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 items-start">
                <RacunPlacanKartica smer="izdani" data={p.data} set={p.set} companyId={companyId} />
                <VkrNastavitveKartica companyId={companyId} />{/* [PATCH miniblagajna-fe v1] */}
                <PopravljanjeRacunaKartica companyId={companyId} />{/* [PATCH izdaja-potrditev-fe v1] */}
                <ZbirniKupecKartica companyId={companyId} />
                {companyId && <PrivzetiSmKartica companyId={companyId} />}{/* [PATCH vod-privzeti-dim-fe v1] */}
              </div>
            </section>)}
          </div>
        )
      )}


      {/* [PATCH nastavitve-zavihki v1] zavihek SPLOSNE NASTAVITVE — obstojeca vsebina, nespremenjena */}
      {tab === 'splosne' && (
      <div className="space-y-6">
      {/* bizBox ePredal */}
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 max-w-2xl">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 rounded-xl bg-blue-50 dark:bg-blue-950 flex items-center justify-center text-blue-600 dark:text-blue-400">
            <Inbox className="w-5 h-5" />
          </div>
          <div>
            <h2 className="font-semibold text-gray-900 dark:text-white">bizBox ePredal</h2>
            <p className="text-xs text-gray-500 dark:text-gray-400">Poverilnice za prevzem eRačunov (gumb »Uvoz iz ePredala«)</p>
          </div>
        </div>
        {nalagam ? (
          <div className="flex items-center justify-center h-24"><Loader className="w-6 h-6 text-blue-500 animate-spin" /></div>
        ) : (
        <div className="mt-4 space-y-4">
          <div>
            <label className="text-xs text-gray-400 block mb-1">Strežnik</label>
            <select value={okolje} onChange={e => setOkolje(e.target.value)}
              className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500 text-sm">
              <option value="demo">bizBox Demo</option>
              <option value="prod">bizBox</option>
            </select>
          </div>
          <div>
            <label className="text-xs text-gray-400 block mb-1">Uporabniško ime</label>
            <input value={uporabnik} onChange={e => setUporabnik(e.target.value)}
              className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500" />
          </div>
          <div>
            <label className="text-xs text-gray-400 block mb-1">Geslo</label>
            <input type="password" value={geslo} onChange={e => setGeslo(e.target.value)}
              placeholder={nastavljeno ? '(nespremenjeno)' : ''}
              className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500" />
            {nastavljeno && <p className="text-[11px] text-gray-500 mt-1">Pusti prazno, da obstoječe geslo ostane.</p>}
          </div>
          <div>
            <label className="text-xs text-gray-400 block mb-1">Prevzemaj dokumente od</label>
            <input type="date" value={odDatuma} onChange={e => setOdDatuma(e.target.value)}
              className="w-full px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500 text-sm [color-scheme:light] dark:[color-scheme:dark]" />
            <p className="text-[11px] text-gray-500 mt-1">Starejši dokumenti ostanejo v ePredalu in se ne uvozijo. Prazno = brez omejitve. Datum lahko kasneje premaknete nazaj — uvozi se, kar še ni v bazi.</p>
          </div>
          <button onClick={shrani} disabled={shranjujem}
            className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl text-sm disabled:opacity-50">
            <Save className="w-4 h-4" />
            <span>{shranjujem ? 'Shranjujem...' : 'Shrani'}</span>
          </button>
        </div>
        )}
      </div>

      {/* [PATCH ddv-blokada v1] Blokada davčnega obdobja */}
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 max-w-2xl">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-950 flex items-center justify-center text-lg">🔒</div>
          <div>
            <h2 className="font-semibold text-gray-900 dark:text-white">Blokada davčnega obdobja</h2>
            <p className="text-xs text-gray-500 dark:text-gray-400">Po oddaji DDV-O zakleni obdobja do vključno vpisanega meseca. Datum za DDV se pri poznih računih samodejno prestavi v prvo odprto obdobje.</p>
          </div>
        </div>
        <div className="mt-4 space-y-3">
          {ddvBlokada && !ddvEdit && (
            <div className="flex items-center gap-3">
              <span className="px-3 py-1.5 rounded-lg bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 text-sm font-semibold">Zaklenjeno do vključno: {ddvBlokada.slice(5,7)}.{ddvBlokada.slice(0,4)}</span>
              <button onClick={() => { setDdvVnos(`${ddvBlokada.slice(5,7)}.${ddvBlokada.slice(0,4)}`); setDdvEdit(true); setDdvSporocilo(''); }} className="text-xs px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:border-blue-400">Spremeni</button>
              <button onClick={() => shraniDdvBlokado('')} disabled={ddvShranjujem} className="text-xs px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-red-500 hover:border-red-400 disabled:opacity-50">Odstrani</button>
            </div>
          )}
          {!ddvBlokada && !ddvEdit && (
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-500 dark:text-gray-400">Ni blokade — vsa obdobja so odprta.</span>
              <button onClick={() => { setDdvVnos(''); setDdvEdit(true); setDdvSporocilo(''); }} className="text-xs px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold">+ Dodaj</button>
            </div>
          )}
          {ddvEdit && (
            <div className="flex items-center gap-2">
              <input autoFocus value={ddvVnos} onChange={e => setDdvVnos(e.target.value)} placeholder="MM.YYYY (npr. 04.2026)"
                onKeyDown={e => { if (e.key === 'Enter') potrdiDdvVnos(); if (e.key === 'Escape') { setDdvEdit(false); setDdvSporocilo(''); } }}
                className="w-44 px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500 text-sm font-mono" />
              <button onClick={potrdiDdvVnos} disabled={ddvShranjujem} className="text-xs px-3 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-50">{ddvShranjujem ? 'Shranjujem...' : 'Shrani'}</button>
              <button onClick={() => { setDdvEdit(false); setDdvSporocilo(''); }} className="text-xs px-3 py-2 rounded-lg text-gray-400 hover:text-gray-300">Prekliči</button>
            </div>
          )}
          {ddvSporocilo && <p className="text-[11px] text-gray-500">{ddvSporocilo}</p>}
        </div>
      </div>

      {/* [PATCH zaklep-leta-fe v1] Zaklep poslovnega leta */}
      {companyId && <ZaklepLetaKartica companyId={companyId} />}

      {/* [PATCH partner-stevilcenje v1] Številčenje partnerjev */}
      <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 max-w-2xl">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-950 flex items-center justify-center text-lg">#</div>
          <div>
            <h2 className="font-semibold text-gray-900 dark:text-white">Številčenje partnerjev</h2>
            <p className="text-xs text-gray-500 dark:text-gray-400">Kako se predlaga šifra (Vasco/Opal/Panteon) novemu partnerju. Predlog lahko ročno spremeniš ob vnosu.</p>
          </div>
        </div>
        <div className="mt-4 space-y-2">
          <label className="flex items-start gap-2 cursor-pointer">
            <input type="radio" name="pstev" checked={pStev === 'davcna'} onChange={async () => { setPStev('davcna'); setPStevSpor(''); try { await api.put(`/companies/${companyId}/partner-stevilcenje`, { partner_stevilcenje: 'davcna' }); setPStevSpor('Shranjeno: po davčni.'); } catch { setPStevSpor('Napaka pri shranjevanju.'); } }} className="mt-0.5" />
            <span className="text-sm"><span className="font-medium text-gray-800 dark:text-gray-200">Po davčni številki</span> <span className="text-gray-500">— šifra = davčna (8-mestna); brez davčne pade na zaporedno.</span></span>
          </label>
          <label className="flex items-start gap-2 cursor-pointer">
            <input type="radio" name="pstev" checked={pStev === 'zaporedje'} onChange={async () => { setPStev('zaporedje'); setPStevSpor(''); try { await api.put(`/companies/${companyId}/partner-stevilcenje`, { partner_stevilcenje: 'zaporedje' }); setPStevSpor('Shranjeno: zaporedno.'); } catch { setPStevSpor('Napaka pri shranjevanju.'); } }} className="mt-0.5" />
            <span className="text-sm"><span className="font-medium text-gray-800 dark:text-gray-200">Zaporedno</span> <span className="text-gray-500">— največja šifra + 1 (do 7 mest, maks. 9999999).</span></span>
          </label>
          {pStevSpor && <p className="text-[11px] text-gray-500">{pStevSpor}</p>}
        </div>

        {/* [PATCH partner-sifra-xml v1] Uvoz novih partnerjev preko XML */}
        <div className="mt-5 pt-4 border-t border-gray-200 dark:border-gray-800">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Uvoz novih partnerjev preko XML</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400">Kako dobi šifro partner, ki ga uvoz XML (VOD, KN-21) na novo doda v šifrant. Partner se nikoli ne shrani brez šifre.</p>
          <div className="mt-3 space-y-2">
            <label className="flex items-start gap-2 cursor-pointer">
              <input type="radio" name="pxml" checked={pXml === false} onChange={async () => { setPXml(false); setPXmlSpor(''); try { await api.put(`/companies/${companyId}/partner-sifra-iz-xml`, { partner_sifra_iz_xml: false }); setPXmlSpor('Shranjeno: po zgornji nastavitvi.'); } catch { setPXmlSpor('Napaka pri shranjevanju.'); } }} className="mt-0.5" />
              <span className="text-sm"><span className="font-medium text-gray-800 dark:text-gray-200">Upoštevaj zgornjo nastavitev</span> <span className="text-gray-500">— šifro določi pravilo zgoraj (po davčni ali zaporedno).</span></span>
            </label>
            <label className="flex items-start gap-2 cursor-pointer">
              <input type="radio" name="pxml" checked={pXml === true} onChange={async () => { setPXml(true); setPXmlSpor(''); try { await api.put(`/companies/${companyId}/partner-sifra-iz-xml`, { partner_sifra_iz_xml: true }); setPXmlSpor('Shranjeno: šifra iz XML, če je prosta.'); } catch { setPXmlSpor('Napaka pri shranjevanju.'); } }} className="mt-0.5" />
              <span className="text-sm"><span className="font-medium text-gray-800 dark:text-gray-200">Prevzemi šifro iz XML</span> <span className="text-gray-500">— če je šifra iz datoteke (Vasco) v tem podjetju prosta, se uporabi ta; sicer velja pravilo zgoraj.</span></span>
            </label>
            {pXmlSpor && <p className="text-[11px] text-gray-500">{pXmlSpor}</p>}
          </div>
        </div>
      </div>

      {/* [PATCH prenos-pdf-nastavitev v1] privzetek kljukice "Priloži PDF" v Prenosih */}
      {companyId && <PrenosPdfKartica companyId={companyId} />}

      {/* Prostor za bodoče sekcije nastavitev */}
      </div>
      )}{/* [PATCH nastavitve-zavihki v1] konec zavihka Splosne nastavitve */}
    </div>
  );
}
